var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.adjustQuotaInfo},[_c('div',{class:_vm.$style.contentIcon}),_vm._v(" "),_c('div',{class:_vm.$style.contentText},[_vm._v("\n    "+_vm._s(_vm.minorText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }